import React from 'react'
import { AlertCircle } from 'react-feather'
import Button from '../../../../components/Button'
import Modal from '../../../../components/Modal'
import { BodyModal, ContainerButton, InfoContainer } from './style'
import * as S from '../ModalAlertTotalFractioned/styles'
import Form from 'src/components/FormComponents/Form'
import FieldV2 from 'src/components/FormComponents/FieldV2'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import theme from 'src/styles/theme'
import { toast } from 'react-toastify'
import { confirmWeightDivergence } from 'src/services/receivement/receivementService'
import { handleOnKeyDown } from 'src/utils/Form'

const schema = yup.object().shape({
  badge: yup.string().trim().required('O crachá do supervisor é obrigatório!'),
})

interface ModalAlertFractionValueProps {
  confirmAction: (e?: React.FormEvent<HTMLFormElement> | undefined) => void
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
  setConfirmedFractionValue: React.Dispatch<React.SetStateAction<boolean>>
  isOpen: boolean
}

const ModalAlertFractionValue = ({
  confirmAction, setIsOpen, setConfirmedFractionValue, isOpen,
}: ModalAlertFractionValueProps) => {
  const {
    handleSubmit, control, reset, formState, setFocus,
  } = useForm({ resolver: yupResolver(schema) })

  const onSubmit = React.useCallback(
    async (data) => {
      const result = await confirmWeightDivergence(data.badge)
      if (result.isOk) {
        setIsOpen(false)
        reset()
        setConfirmedFractionValue(true)
        confirmAction()
      } else {
        setFocus('badge')
        toast.error(result?.data?.message || 'Falha ao validar o crachá do supervisor!')
      }
    },
    [confirmAction, setIsOpen, reset, setConfirmedFractionValue, setFocus],
  )

  const cancelModal = () => {
    setIsOpen(false)
    reset()
    setConfirmedFractionValue(false)
  }

  return (
    <Modal
      testId='modal-fraction-value'
      show={isOpen}
      closedButton={false}
      title='ATENÇÃO'
      body={(
        <BodyModal>
          <S.Form as={Form} onSubmit={undefined}>
            <InfoContainer>
              <h6>
                <AlertCircle
                  size='34px'
                  color={theme.colors.yellow}
                  style={{ marginRight: '10px' }}
                />
                O valor da fração inserido é um valor considerado ANORMAL para
                esse SKU
              </h6>

              <S.InputContainer>
                <S.InputLabel htmlFor='badge'>Crachá do supervisor</S.InputLabel>
                <S.Field
                  as={FieldV2}
                  type='password'
                  name='badge'
                  autoFocus
                  autoComplete='off'
                  control={control}
                  onKeyDown={(e) => handleOnKeyDown<HTMLInputElement>(e, 'confirmButton', () => { document.getElementById('confirmButton')?.click() })}
                  showErrorContainer
                  testId='badge-input'
                />
              </S.InputContainer>
            </InfoContainer>

            <ContainerButton>
              <Button
                id='confirmButton'
                type='button'
                text='Confirmar'
                onClick={handleSubmit((data) => onSubmit(data))}
                color={theme.colors.blue}
                isDisabled={formState.isSubmitting}
                testId='button-confirm'
              />
              <Button
                text='Cancelar'
                onClick={() => cancelModal()}
                color={theme.colors.red2}
                testId='button-cancel'
              />
            </ContainerButton>
          </S.Form>
        </BodyModal>
      )}
    />
  )
}

export default ModalAlertFractionValue
